import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'
import TncModalLink from '../../../../components/home/TncModalLink/TncModalLink'
import PrivacyPolicyLink from '../../../../components/home/PrivacyModalLink/PrivacyModalLink'

import RightSideBarHeader from '../../../../assets/img/right-sidebar-header.svg'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'

import {
  MAIN,
  FAQ_PAGE,
  SHARE_FEEDBACK,
} from '../../../../services/data/profilePages.json'

const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
`

const Header = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  min-height: 87px;
  font-size: 0.7rem;
  z-index: 100;

  ${props =>
    props.hasScrolled &&
    css`
    background: url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-repeat: no-repeat;
    background-position: right top;
  `}
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const PageBody = styled.div`
  &::before {
    content: ' ';
    display: block;
    height: 197px;
    background-color: var(--color-primary);
    background: url('${RightSideBarHeader}'), url('${MoreHeaderParticles}'), linear-gradient(var(--color-primary), var(--color-primary));
    background-position: bottom, right top;
    background-repeat: no-repeat;
    background-size: 100%, auto;
  }
`

const ProfileNav = styled.ul`
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 1.5rem;
  padding: 0 1.1875rem;
`

const NavItem = styled.li`
  color: var(--color-primary);
  cursor: pointer;
  list-style: none;
  padding: 1rem 0;
  border-top: 1px solid var(--color-fg-lighter);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  svg {
    color: var(--color-primary);
  }
`

const ItemName = styled.span`
  flex-grow: 1;
  padding-left: 5px;
  font-size: 0.875rem;
  color: var(--color-primary);

  &:hover {
    color: var(--color-primary-hover);
  }
`

const StyledTncModalLink = styled(TncModalLink).attrs({ zIndex: '10021' })`
  display: block;
  margin: -20px;
  padding: 20px;
  margin-right: -30px;
  padding-right: 30px;

  &:hover {
    color: unset;
  }
`
const StyledPrivacyPolicyLink = styled(PrivacyPolicyLink).attrs({
  zIndex: '10022',
})`
  display: block;
  margin: -20px;
  padding: 20px;
  margin-right: -30px;
  padding-right: 30px;

  &:hover {
    color: unset;
  }
`

class HelpCenterPage extends React.Component {
  state = {
    scrollPosition: 0,
    hasScrolled: false,
  }

  currentPage = React.createRef()

  componentDidMount() {
    this.currentPage.current.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    this.currentPage.current.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = event => {
    const { hasScrolled: hasScrolledState } = this.state
    const { scrollTop } = event.target
    const hasScrolled = scrollTop > 0

    if (hasScrolled !== hasScrolledState) {
      this.setState({
        hasScrolled,
      })
    }
  }

  render() {
    const { hasScrolled } = this.state
    const { setProfileModalPage, accessToken } = this.props

    return (
      <MainPage ref={this.currentPage}>
        <Header hasScrolled={hasScrolled}>
          <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
            <Icon name="slide-left" />
          </ReturnIcon>
          <Title>Help Center</Title>
        </Header>
        <PageBody small={!accessToken}>
          <ProfileNav>
            <NavItem onClick={() => setProfileModalPage(FAQ_PAGE)}>
              <ItemName>Frequently Asked Questions</ItemName>
              <Icon name="slide-right" />
            </NavItem>
            <NavItem onClick={() => setProfileModalPage(SHARE_FEEDBACK)}>
              <ItemName>Share your Feedback</ItemName>
              <Icon name="slide-right" />
            </NavItem>
            <NavItem>
              <ItemName>
                <StyledTncModalLink>Terms & Conditions</StyledTncModalLink>
              </ItemName>
              <Icon name="slide-right" />
            </NavItem>
            <NavItem>
              <ItemName>
                <StyledPrivacyPolicyLink>
                  Privacy Notice
                </StyledPrivacyPolicyLink>
              </ItemName>
              <Icon name="slide-right" />
            </NavItem>
          </ProfileNav>
        </PageBody>
      </MainPage>
    )
  }
}

HelpCenterPage.defaultProps = {}

HelpCenterPage.propTypes = {
  primaryInfo: PropTypes.object,
}

export default HelpCenterPage
